import capas from './capas';
import units from './units';
import events from './events';
import photos from './photos';
import files from './files';    
import missions from './missions';
import reports from './reports';
import videos from './videos';
import security from './security';
import { de } from 'vuetify/locale';

const api = {
  ...capas,
  ...units,
  ...events,
  ...photos,
  ...files,
  ...missions,
  ...reports,
  ...videos,
  ...security
};

export default api;